/*
 * TUMLE side menu: fit the drawer to the space actually left on screen, so
 * its bottom row (currency, social links) is always in view. The theme sizes
 * it from --header-bottom-position, which misses bars above the header (the
 * top bar, a campaign bar) and leaves the bottom row below the fold.
 * Loaded by sections/header.liquid.
 */
(function () {
  function fit() {
    var drawer = document.getElementById('menu-drawer');
    var details = document.getElementById('Details-menu-drawer-container');
    if (!drawer || !details || !details.open) return;
    var top = drawer.getBoundingClientRect().top;
    var height = Math.round(window.innerHeight - top);
    if (height > 0) drawer.style.height = height + 'px';
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest || !event.target.closest('header-drawer summary')) return;
    // After the theme has opened the drawer and set its own size
    requestAnimationFrame(function () { requestAnimationFrame(fit); });
  });

  window.addEventListener('resize', fit);
})();
